module.exports = __webpack_public_path__ + "media/assets/Question_circle-f76cb7d0e3154bf26db7dceba5b89e05.png";